export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20top-down%20flat%20lay%20composition%20of%20carefully%20curated%20fashion%20items%20including%20designer%20sneakers%2C%20cashmere%20sweaters%2C%20leather%20accessories%2C%20sunglasses%2C%20and%20a%20sleek%20silver%20laptop%20on%20a%20textured%20linen%20surface%2C%20soft%20diffused%20skylight%20from%20above%2C%20muted%20desert%20rose%20and%20sage%20green%20palette%2C%20editorial%20lifestyle%20photography%2C%20thoughtful%20negative%20space%2C%20sophisticated%20minimalist%20aesthetic%20with%20subtle%20botanical%20elements&width=1800&height=1200&seq=hero-bg-hipobuy-v2-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet lifestyle shopping scene"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-16 max-w-[1400px] mx-auto pt-24 lg:pt-0">
          <div className="flex-1 flex flex-col items-start justify-center min-h-[60vh] lg:min-h-screen py-20 lg:py-32">
            <span className="inline-block text-xs font-medium text-primary-500 tracking-widest uppercase mb-4 bg-primary-50 px-3 py-1 rounded-full">
              Updated 2026
            </span>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-950 leading-[1.08] max-w-2xl">
              Hipobuy{' '}
              <span className="italic font-normal">Spreadsheet</span>
              <br />
              <span className="text-foreground-700 font-normal text-2xl md:text-3xl lg:text-4xl xl:text-5xl block mt-3">
                Your Ultimate Shopping Research &amp; Product Discovery Guide
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-lg leading-relaxed">
              Discover the latest Hipobuy Spreadsheet resources, verified product guides, comparison tables, and expert shopping tips. Find better products faster with organized spreadsheet research.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-background-50 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
              >
                hipobuy sheet
                <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-background-100 text-foreground-950 border border-background-300 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-200 transition-colors"
              >
                buy it now
                <i className="ri-shopping-bag-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-10 text-sm text-foreground-500">
              <span className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                Updated Resources
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                Product Comparisons
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                Beginner Friendly
              </span>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center min-h-screen py-20">
            <div className="relative w-full max-w-lg">
              <div className="relative rounded-3xl overflow-hidden bg-background-100/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20product%20arrangement%20of%20premium%20streetwear%20items%20including%20limited%20edition%20sneakers%2C%20a%20folded%20graphic%20hoodie%2C%20a%20crossbody%20bag%2C%20and%20a%20baseball%20cap%20on%20a%20concrete%20pedestal%2C%20dramatic%20gallery%20spotlight%20from%20above%2C%20deep%20charcoal%20background%2C%20museum-like%20presentation%2C%20high%20contrast%20lighting%20emphasizing%20textures%20and%20silhouettes%2C%20luxury%20street%20fashion%20exhibition%20aesthetic&width=800&height=1000&seq=hero-side-hipobuy-v2-2026&orientation=portrait"
                  alt="Curated Hipobuy Spreadsheet products"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>

              <div className="absolute -bottom-6 -left-6 bg-background-50 rounded-2xl px-5 py-4">
                <p className="text-xs text-foreground-500">Popular Category</p>
                <p className="text-lg font-bold text-foreground-950 font-heading">Shoes</p>
                <a
                  href="https://kaspreadsheet.com/category-911-Shoes.html"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer mt-1 inline-block"
                >
                  Explore &rarr;
                </a>
              </div>

              <div className="absolute -top-4 -right-4 bg-accent-500 text-background-50 rounded-full w-16 h-16 flex flex-col items-center justify-center">
                <span className="text-lg font-bold leading-none">500+</span>
                <span className="text-[9px] leading-tight mt-0.5">Categories</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100/80 cursor-pointer">
          <i className="ri-arrow-down-line text-foreground-400 w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}